export const iconFontAwesomeNaturePlantWilt = (
	<i className="fa-solid fa-plant-wilt"></i>
);
